/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{margin-bottom:30px}app-button[_ngcontent-%COMP%]{display:inline-block;white-space:nowrap;margin:0 10px 10px 0}.browse-title[_ngcontent-%COMP%]{font-size:16px;font-weight:700;color:#31365f;margin-bottom:14px}"];
export { styles as styles };
